// extracted by mini-css-extract-plugin
module.exports = {"sliderWrapper":"slick_sliderWrapper__XkPRq","rba":"slick_rba__1tBwn"};